export const config = {
  title: "Payel Ghosh Real Estate | Kirkland, WA",
  meta: {
    description:
      "Explore your next dream home with Payel Ghosh Real Estate in Kirkland, WA. Trusted local real estate expertise for buying and selling properties across Washington.",
    keywords: [
      "Payel Ghosh",
      "Real Estate Kirkland WA",
      "Homes for sale Washington",
      "Kirkland realtor",
      "WA property listings"
    ],
    author: "Payel Ghosh Real Estate",
    canonicalUrl: "https://www.payelghoshrealestate.com/payel-ghosh/",
  },
  sections: {
    header: {
      businessName: "Payel Ghosh Real Estate",
    },
    sectionB: {
      heroTitle: "Payel Ghosh Real Estate",
      heroSubtitle: "Your Trusted Realtor in Kirkland, WA",
      learnAboutText: "Browse Listings",
      phoneNumber: "14254991243",
      phoneLabel: "(425) 499-1243",
      heroBackgroundImage:
      "https://media.istockphoto.com/id/2163132165/photo/houses-align-a-residential-district-next-to-road.jpg?s=612x612&w=0&k=20&c=JwTatZ7qyrv0s0UZa6yZ_WpByb_0M7GN9ZXZQOrWWRk=",
      cardData: [
        {
          title: "Home Buying",
          description: "Find the perfect property that fits your lifestyle and budget.",
        },
        {
          title: "Home Selling",
          description: "Maximize your property’s value with expert listing services.",
        },
        {
          title: "Local Expertise",
          description: "Serving Kirkland, Seattle, Bellevue, and surrounding WA areas.",
        },
      ],
      description:
        "With an in-depth knowledge of the local real estate market, Payel Ghosh provides tailored solutions for home buyers and sellers throughout Washington.",
    },
    sectionC: {
      servicesTitle: "What We Offer",
      servicesDescription:
        "From curated listings to personalized consultations, discover how we make real estate simple and effective.",
      cards: [
        {
          title: "Buyer Representation",
          description: "Negotiation, tours, and expert guidance through your home purchase.",
          imageSrc: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?q=80&w=2070",
          imageAlt: "Buying property",
        },
        {
          title: "Seller Services",
          description: "Professional marketing, staging, and showing to get your home sold fast.",
          imageSrc: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?q=80&w=2070",
          imageAlt: "Selling home",
        },
        {
          title: "Relocation Assistance",
          description: "Seamless transition to or from the Kirkland area.",
          imageSrc: "https://images.unsplash.com/photo-1557804506-669a67965ba0?q=80&w=2070",
          imageAlt: "Relocation services",
        },
      ],
      otherServicesTitle: "Why Choose Payel Ghosh",
      otherServicesList: [
        "Top-rated local expertise",
        "Client-first approach",
        "Skilled negotiator",
        "Transparent and honest communication",
        "Wide network in the WA housing market"
      ],
    },
    sectionD: {
      aboutTitle: "About Payel Ghosh Real Estate",
      aboutImage: {
        src: "https://u.realgeeks.media/payelghoshrealestate/98fd68bb0c71-10.jpg",
        alt: "Payel Ghosh Headshot",
      },
      aboutText: [
        "With a passion for helping clients achieve their real estate goals, Payel Ghosh has built a reputation for delivering exceptional service.",
        "Whether you’re a first-time buyer or seasoned investor, she brings insight, integrity, and dedication to every transaction.",
      ],
    },
    sectionE: {
      profileImage: "https://t2.realgeeks.media/thumbnail/MV5SfMcxC9YIX88oGoFqCllyfi0=/fit-in/400x86/filters:format(png)/u.realgeeks.media/payelghoshrealestate/8deda884dd7e-KW_logo.png",
      profileAlt: "Payel Ghosh",
      businessName: "Payel Ghosh Real Estate",
      contact: {
        phone: "14254991243",
        phoneLabel: "(425) 499-1243",
        email: "payelg@outlook.com",
        website: "https://www.payelghoshrealestate.com/payel-ghosh/",
        address: "11109 Slater Ave NE #200A, Kirkland, WA 98033, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "11109 Slater Ave NE #200A, Kirkland, WA 98033, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=11109+Slater+Ave+NE+%23200A,+Kirkland,+WA+98033&output=embed",
    },
  },
};

export default config;
